import { render } from "./ProductEditModal.vue?vue&type=template&id=1da69088&scoped=true"
import script from "./ProductEditModal.vue?vue&type=script&lang=js"
export * from "./ProductEditModal.vue?vue&type=script&lang=js"

import "./ProductEditModal.vue?vue&type=style&index=0&id=1da69088&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1da69088"

export default script